// extracted by mini-css-extract-plugin
export var boxItems = "_bo-1";
export var boxItemsLg = "_bo-2";
export var button = "_bo-7";
export var buttonLg = "_bo-8";
export var filterGroupBox = "_bo-0";
export var icon = "_bo-3";
export var iconSecondary = "_bo-6";
export var iconWrapper = "_bo-4";
export var iconWrapperLg = "_bo-5";